import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService } from '@app/services';
import { IVaultPasswordPolicyDTO } from '@app/models';
import { defaultOrgId } from '@app/helpers';

class VaultPasswordPolicyService {
    readonly apiBase: string = '/api/directory/passwordserverpolicies/Policies';

    getVaultPasswordPoliciesDTO(skip: number): AxiosPromise {
        return apiService.get(`${this.apiBase}`,
            {
                params: {
                    $orderBy: 'DisplayName asc',
                    $top: 100,
                    $skip: skip,
                    $count: true,
                    $filter: `OrganizationId eq ${defaultOrgId}`
                },
            })
            .catch();
    }

    getAllVaultPasswordPolicies = () => {
        let values: IVaultPasswordPolicyDTO[] = [];
        let count = 0;

        const getVaultPasswordPolicies = (): Promise<IVaultPasswordPolicyDTO[]> => {
            return vaultPasswordPolicyService
            .getVaultPasswordPoliciesDTO(count)
            .then((resp: AxiosResponse) => {
                count += resp.data.value.length;
                values = [...values, ...resp.data.value];

                if (count < resp.data['@odata.count']) {
                    return getVaultPasswordPolicies();
                } else {
                    return values;
                }
            });
        };

        return getVaultPasswordPolicies();
    };
}

export const vaultPasswordPolicyService = new VaultPasswordPolicyService();
